import localforage from "../utils/localforage";
import http from "../utils/api";
import moment from "moment";

export async function getSaldoHorasDia() {
  let periodo = await localforage.getItem("periodo");
  const response = await http.get("apontamentos/saldo-horas-dia", {
    params: {
      dataInicio: moment(periodo.inicio)
        .subtract(1, "months")
        .format("YYYY-MM-DD"),
      dataFim: moment().add(1, 'day').format('YYYY-MM-DD'),
    },
  });
  let saldoHorasDia = response?.data.data ?? [];
  await localforage.setItem("saldo-horas-dia", saldoHorasDia);
  return saldoHorasDia;
}
